import { render, staticRenderFns } from "./UploadsEditor.vue?vue&type=template&id=5f361c38&scoped=true&"
import script from "./UploadsEditor.vue?vue&type=script&lang=js&"
export * from "./UploadsEditor.vue?vue&type=script&lang=js&"
import style0 from "./UploadsEditor.vue?vue&type=style&index=0&id=5f361c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f361c38",
  null
  
)

export default component.exports